import type { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
  title?: string
  subtitle?: string
}

export function AuthLayout({
  children,
  subtitle = 'AI-powered Media analysis',
}: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-background p-4">
      <div className="pointer-events-none absolute right-[-80px] top-[-80px] h-56 w-56 rounded-full bg-primary-soft blur-3xl" />
      <div className="pointer-events-none absolute bottom-[-80px] left-[-80px] h-56 w-56 rounded-full bg-primary-soft blur-3xl" />
      <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-sm">
        {/* Logo Section */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <a href="https://www.myralabs.ai" target="_blank" rel="noreferrer">
              <div className="flex items-center gap-2">
                <svg width="24" height="24" viewBox="0 0 26 26" fill="none">
                  <circle cx="13" cy="13" r="12" stroke="#6366F1" strokeWidth="2" />
                  <circle cx="13" cy="13" r="6.5" fill="#6366F1" opacity=".5" />
                  <circle cx="13" cy="13" r="3" fill="#EDF0FF" />
                </svg>
                <span className="font-semibold tracking-tight">
                  myra<span className="text-muted-foreground">labs</span>
                  <em className="not-italic text-primary">.ai</em>
                </span>
              </div>
            </a>
          </div>
          <p className="text-sm text-muted-foreground">
            {subtitle}
          </p>
        </div>

        {/* Auth Form Container */}
        <div className="overflow-hidden rounded-[10px] border border-border bg-card p-4 shadow-none">
          {children}
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-xs text-muted-foreground">
            © 2025 Myra. All rights reserved.
          </p>
        </div>
      </div>
    </div>
    </div>
  )
}
